import React, {Component} from 'react';
import NavBar from "./NavBar";
import LoginJumbotron from "./LoginJumbotron";

class Main extends Component {
    render() {
        return (
            <div>
                <NavBar />
                <LoginJumbotron />
            </div>
        );
    }
}

export default Main;